import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import './plugins/element.js'
import Element from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import './style/element-variables.scss'
import './assets/css/global.css'
import htmlToExcel from './utils/Excel'
Vue.prototype.Excels = htmlToExcel
Vue.use(Element, { locale })

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
